import React, { useEffect, useState } from 'react';
import '../../styles/website.css';

const PartnershipTermsPage: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  useEffect(() => {
    document.title = 'Partnerlik Koşulları - SobCof';
  }, []);

  return (
    <div className="page-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="/" className="logo-link">
              <img src="/assets/LogoBrown.png" alt="SobCof Logo" className="logo-image" />
            </a>
          </div>
          <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <a href="/" className="nav-link">Ana Sayfa</a>
            <a href="/feedback" className="nav-link">Geri Bildirim</a>
            <a href="/help" className="nav-link">Yardım</a>
            <a href="/contact" className="nav-link">İletişim</a>
            <a href="/cafe-partnership" className="nav-link">Kafe Partnerliği</a>
          </div>
          <div className="nav-toggle" onClick={toggleMobileMenu}>
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">Partnerlik Koşulları</h1>
            <p className="hero-subtitle">
              SobCof Kafe Partnerlik Programı şartları ve koşulları
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="content-section">
        <div className="content-container">
          <div className="terms-content">
            
            {/* Giriş */}
            <div className="terms-section">
              <h2>1. Partnerlik Programına Giriş</h2>
              <p>
                SobCof Kafe Partnerlik Programı, kafe sahiplerinin SobCof uygulaması üzerinden
                müşterilerine daha iyi hizmet vermelerini ve yeni müşteriler kazanmalarını
                sağlamak amacıyla geliştirilmiştir.
              </p>
            </div>

            {/* Başvuru Koşulları */}
            <div className="terms-section">
              <h2>2. Başvuru Koşulları</h2>
              <ul>
                <li>Kafe/restoran sahibi veya yetkili temsilcisi olmak</li>
                <li>Geçerli bir işletme ruhsatına sahip olmak</li>
                <li>Türkiye sınırları içerisinde faaliyet göstermek</li>
                <li>Müşteri hizmetleri standartlarına uygun hizmet vermek</li>
                <li>SobCof kalite standartlarını kabul etmek</li>
              </ul>
            </div>

            {/* Partner Hakları */}
            <div className="terms-section">
              <h2>3. Partner Hakları ve Avantajları</h2>
              <div className="benefits-grid">
                <div className="benefit-item">
                  <h4>📱 Uygulama Görünürlüğü</h4>
                  <p>Kafeniniz SobCof uygulamasında özel partner rozetiyle görüntülenir</p>
                </div>
                <div className="benefit-item">
                  <h4>📸 Profesyonel Fotoğraf Çekimi</h4>
                  <p>Kafenizin profesyonel fotoğrafları SobCof ekibi tarafından çekilir ve yüklenir</p>
                </div>
                <div className="benefit-item">
                  <h4>🏷️ Partner Rozeti</h4>
                  <p>Özel "SobCof Partner" rozetiyle güvenilirlik kazanırsınız</p>
                </div>
                <div className="benefit-item">
                  <h4>📍 Harita Entegrasyonu</h4>
                  <p>Google Haritalar entegrasyonu ile kolay bulunabilirlik</p>
                </div>
                <div className="benefit-item">
                  <h4>📊 Gerçek Zamanlı Takip</h4>
                  <p>Kafenizdeki aktif kullanıcı sayısını uygulamadan takip edebilirsiniz</p>
                </div>
                <div className="benefit-item">
                  <h4>💬 Doğrudan İletişim</h4>
                  <p>Müşterilerle platform üzerinden iletişim kurabilirsiniz</p>
                </div>
              </div>
            </div>

            {/* Partner Sorumlulukları */}
            <div className="terms-section">
              <h2>4. Partner Sorumlulukları</h2>
              <ul>
                <li>Doğru ve güncel kafe bilgileri sağlamak</li>
                <li>Kaliteli hizmet standartlarını sürdürmek</li>
                <li>Müşteri şikayetlerini zamanında çözmek</li>
                <li>SobCof markasına zarar verecek davranışlardan kaçınmak</li>
                <li>Platform kurallarına ve yasal düzenlemelere uymak</li>
                <li>Kafe bilgilerinde değişiklik olduğunda bildirimde bulunmak</li>
              </ul>
            </div>

            {/* Onay Süreci */}
            <div className="terms-section">
              <h2>5. Başvuru ve Onay Süreci</h2>
              <div className="process-steps">
                <div className="process-step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Başvuru Formu</h4>
                    <p>Online başvuru formunu eksiksiz doldurun</p>
                  </div>
                </div>
                <div className="process-step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>İnceleme</h4>
                    <p>Başvurunuz 48 saat içinde değerlendirilir</p>
                  </div>
                </div>
                <div className="process-step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h4>Onay</h4>
                    <p>Onaylanan başvurular e-posta ile bilgilendirilir</p>
                  </div>
                </div>
                <div className="process-step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h4>Aktivasyon</h4>
                    <p>Kafeniniz uygulamada yayına alınır</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Ücretlendirme */}
            <div className="terms-section">
              <h2>6. Ücretlendirme Politikası</h2>
              <div className="pricing-info">
                <div className="pricing-packages">
                  <h3>Mevcut Fiyatlandırma</h3>
                  <div className="pricing-table">
                    <div className="pricing-row">
                      <span className="package-name">1 Aylık Paket</span>
                      <span className="package-price">550 ₺</span>
                      <span className="package-monthly">550 ₺/ay</span>
                    </div>
                    <div className="pricing-row">
                      <span className="package-name">6 Aylık Paket</span>
                      <span className="package-price">3.150 ₺</span>
                      <span className="package-monthly">525 ₺/ay <span className="discount-badge">%5 İndirim</span></span>
                    </div>
                    <div className="pricing-row highlight-row">
                      <span className="package-name">1 Yıllık Paket</span>
                      <span className="package-price">6.000 ₺</span>
                      <span className="package-monthly">500 ₺/ay <span className="discount-badge best">%9 İndirim</span></span>
                    </div>
                  </div>
                </div>
                <div className="included-features">
                  <h3>Dahil Özellikler</h3>
                  <ul>
                    <li><i className="fas fa-check"></i> Uygulama Görünürlüğü</li>
                    <li><i className="fas fa-check"></i> QR Menü Sistemi</li>
                    <li><i className="fas fa-check"></i> Partner Rozeti</li>
                    <li><i className="fas fa-check"></i> Harita Entegrasyonu</li>
                    <li><i className="fas fa-check"></i> Gerçek Zamanlı Takip</li>
                    <li><i className="fas fa-check"></i> Pazarlama Araçları</li>
                    <li><i className="fas fa-check"></i> Profil Sayfası</li>
                    <li><i className="fas fa-check"></i> Paylaşım İmkanı</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Partnerlik İptali */}
            <div className="terms-section">
              <h2>7. Partnerliğin Sona Ermesi</h2>
              <h3>Partner Tarafından İptal</h3>
              <ul>
                <li>7 gün önceden yazılı bildirim</li>
                <li>Mevcut kampanyaların tamamlanması</li>
                <li>Kafe bilgilerinin platformdan kaldırılması</li>
              </ul>
              
              <h3>SobCof Tarafından İptal</h3>
              <p>Aşağıdaki durumlarda partnerlik iptal edilebilir:</p>
              <ul>
                <li>Sözleşme koşullarının ihlali</li>
                <li>Kalite standartlarına uyulmaması</li>
                <li>Müşteri şikayetlerinin çözülmemesi</li>
                <li>Yasal düzenlemelere aykırı davranış</li>
              </ul>
            </div>

            {/* Veri Koruma */}
            <div className="terms-section">
              <h2>8. Veri Koruma ve Gizlilik</h2>
              <ul>
                <li>Kafe bilgileri KVKK kapsamında korunur</li>
                <li>Müşteri verileri güvenli şekilde işlenir</li>
                <li>Üçüncü taraflarla veri paylaşımı yapılmaz</li>
                <li>Veri silme talebi 30 gün içinde karşılanır</li>
              </ul>
            </div>

            {/* İletişim */}
            <div className="terms-section">
              <h2>9. İletişim ve Destek</h2>
              <p>
                Partnerlik programı hakkında sorularınız için:
              </p>
              <ul>
                <li><strong>E-posta:</strong> sobcof@gmail.com</li>
              </ul>
            </div>

            {/* Son Güncelleme */}
            <div className="terms-section">
              <h2>10. Koşulların Güncellenmesi</h2>
              <p>
                Bu koşullar SobCof tarafından güncellenebilir. Önemli değişiklikler 
                partnerlerimize e-posta ile bildirilir. Değişikliklerin yürürlüğe 
                girme tarihi 30 gün önceden duyurulur.
              </p>
              <p className="update-date">
                <strong>Son Güncelleme:</strong> 23 Ocak 2026
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2>Hemen Başvuru Yapın!</h2>
          <p>SobCof Partner Kafe olmak için şimdi başvurun, avantajlardan yararlanmaya başlayın.</p>
          <a href="/cafe-partnership" className="cta-button">
            Partnerlik Başvurusu Yap
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <a href="/" className="logo-link">
                  <img src="/assets/LogoWhite.png" alt="SobCof Logo" />
                </a>
              </div>
              <p className="footer-description">
                Kahve severler için sosyal keşif platformu. En iyi kafeleri keşfet, yeni insanlarla tanış.
              </p>
              <div className="social-links">
                <a href="https://instagram.com/sobcof" title="Instagram" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://tiktok.com/@sobcof" title="TikTok" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                <a href="https://twitter.com/sobcof" title="Twitter" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a href="https://youtube.com/@sobcof" title="YouTube" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              </div>
            </div>
            
            <div className="footer-section">
              <h4>Ürün</h4>
              <ul>
                <li><a href="/#features">Özellikler</a></li>
                <li><a href="/#premium">Premium</a></li>
                <li><a href="/#download">İndir</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Destek</h4>
              <ul>
                <li><a href="/help">Yardım Merkezi</a></li>
                <li><a href="/contact">İletişim</a></li>
                <li><a href="/feedback">Geri Bildirim</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Yasal</h4>
              <ul>
                <li><a href="/privacy">Gizlilik Politikası</a></li>
                <li><a href="/terms">Kullanım Koşulları</a></li>
                <li><a href="/cookies">Çerez Politikası</a></li>
                <li><a href="/gdpr">KVKK</a></li>
              </ul>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; 2026 SobCof. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PartnershipTermsPage;
